import {
  AvgDaysToFulfillOverTimeRequestSchema,
  AvgDaysToFulfillOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgDaysToFulfillOverTime = {
  name: "getAvgDaysToFulfillOverTime" as const,
  input: AvgDaysToFulfillOverTimeRequestSchema,
  output: AvgDaysToFulfillOverTimeResponseSchema,
};
